{
  "dashboard": {
    "title": "Admin Dashboard",
    "loading": "Loading...",
    "welcomeBack": "Welcome back, {{name}}. Here is your platform overview.",
    "platformOverview": "Platform overview — manage tenants, users, and system health at a glance.",
    "refresh": "Refresh",
    "aiSettings": "AI Settings",
    "servicesUnreachable": "Some services are unreachable",
    "failedClients": "Failed to load clients data.",
    "failedUsers": "Failed to load users data.",
    "retry": "Retry",
    "stats": {
      "clients": "Clients",
      "companies": "Companies",
      "users": "Users",
      "modules": "Modules"
    },
    "quickActions": {
      "title": "Quick Actions",
      "manageClients": "Manage Clients",
      "manageClientsDesc": "View and manage client accounts",
      "userManagement": "User Management",
      "userManagementDesc": "View users and their roles",
      "aiSettings": "AI Settings",
      "aiSettingsDesc": "Global AI configuration",
      "aiLogs": "AI Logs",
      "aiLogsDesc": "View AI operation logs"
    },
    "systemHealth": {
      "title": "System Health",
      "allOperational": "All Operational",
      "issuesDetected": "Issues Detected",
      "authService": "Auth Service",
      "userDirectory": "User Directory",
      "tenantRegistry": "Tenant Registry",
      "moduleRegistry": "Module Registry",
      "operational": "Operational",
      "apiUnreachable": "API unreachable",
      "cannotFetchUsers": "Cannot fetch users",
      "cannotFetchClients": "Cannot fetch clients",
      "registered": "{{count}} registered",
      "clients": "{{count}} clients"
    },
    "recentClients": "Recent Clients",
    "recentUsers": "Recent Users",
    "viewAll": "View All ({{count}})",
    "userRoleDistribution": "User Role Distribution",
    "topClientsByCompanies": "Top Clients by Companies",
    "registeredModules": "Registered Modules",
    "noUserData": "No user data available",
    "noClientData": "No client data available",
    "failedLoadClients": "Failed to load clients",
    "noClientsYet": "No clients yet",
    "failedLoadUsers": "Failed to load users",
    "noUsersYet": "No users yet",
    "company": "company",
    "companies": "companies",
    "table": {
      "client": "Client",
      "companies": "Companies",
      "created": "Created",
      "user": "User",
      "role": "Role",
      "memberships": "Memberships",
      "clientCount": "{{count}} client(s)",
      "companyCount": "{{count}} company(ies)",
      "tenantCount": "{{count}} tenant",
      "tenantCount_plural": "{{count}} tenants"
    }
  },
  "ai": {
    "general": {
      "title": "AI General Settings",
      "subtitle": "Configure global AI settings and system parameters.",
      "totalRequests": "Total Requests",
      "successRate": "Success Rate",
      "avgResponseTime": "Avg Response Time",
      "activeModels": "Active Models",
      "tabs": {
        "api": "API Configuration",
        "performance": "Performance",
        "monitoring": "Monitoring",
        "security": "Security"
      },
      "fields": {
        "modelProvider": "Model Provider",
        "modelProviderRequired": "Please select a model provider",
        "modelProviderPlaceholder": "Select model provider",
        "apiKey": "API Key",
        "apiKeyRequired": "Please enter API key",
        "apiKeyPlaceholder": "Enter API key",
        "maxTokens": "Max Tokens",
        "maxTokensRequired": "Please enter max tokens",
        "maxTokensPlaceholder": "Maximum tokens per request",
        "temperature": "Temperature",
        "temperatureRequired": "Please enter temperature",
        "temperaturePlaceholder": "Model temperature (0-2)",
        "requestTimeout": "Request Timeout (seconds)",
        "timeoutRequired": "Please enter timeout",
        "timeoutPlaceholder": "Request timeout in seconds",
        "retryAttempts": "Retry Attempts",
        "retryAttemptsRequired": "Please enter retry attempts",
        "retryAttemptsPlaceholder": "Number of retry attempts",
        "enableCaching": "Enable Response Caching",
        "cacheExpiry": "Cache Expiry (seconds)",
        "cacheExpiryRequired": "Please enter cache expiry",
        "cacheExpiryPlaceholder": "Cache expiry in seconds",
        "enableRateLimit": "Enable Rate Limiting",
        "rateLimit": "Rate Limit (requests per minute)",
        "rateLimitRequired": "Please enter rate limit",
        "rateLimitPlaceholder": "Requests per minute",
        "enableLogging": "Enable AI Logging",
        "enableMonitoring": "Enable Performance Monitoring",
        "alertThreshold": "Alert Threshold (%)",
        "alertThresholdRequired": "Please enter alert threshold",
        "alertThresholdPlaceholder": "Alert threshold percentage",
        "logAllRequests": "Log All AI Requests",
        "enableEncryption": "Enable Request Encryption",
        "enableIpWhitelist": "Enable IP Whitelisting"
      },
      "security": {
        "title": "Security Settings",
        "description": "Configure security parameters for AI model access and data protection."
      },
      "saveNotice": "Changes will take effect after saving and restarting the AI service.",
      "reset": "Reset",
      "saveSettings": "Save Settings",
      "settingsSaved": "Settings saved successfully",
      "checkInput": "Please check your input",
      "settingsReset": "Settings reset to default values"
    },
    "logs": {
      "title": "Platform logs",
      "subtitle": "Flow executions across all tenants and the audit trail of flow and template changes."
    }
  },
  "tenants": {
    "title": "Tenants Management",
    "subtitle": "Manage tenant accounts and their associated companies. Create, configure, and monitor tenant access across the platform.",
    "clients": "Tenants",
    "addClient": "Add Tenant",
    "paginationTotal": "{{start}}-{{end}} of {{total}} tenants",
    "search": "Search",
    "searchPlaceholder": "Search by tenant name",
    "searchPending": "Searching…",
    "searchResults": "{{count}} tenants matching \"{{query}}\"",
    "noSearchResults": "No tenants match \"{{query}}\"",
    "clearFilters": "Clear filters",
    "columns": {
      "client": "Tenant",
      "companies": "Companies",
      "status": "Status",
      "createdAt": "Created",
      "lastUpdated": "Last Updated",
      "actions": "Actions"
    },
    "active": "Active",
    "created": "Created {{time}}",
    "manageClient": "Manage tenant",
    "manageClientTooltip": "Manage tenant settings",
    "moduleManagement": "Module management",
    "moduleManagementTooltip": "Configure modules",
    "editClient": "Edit Tenant",
    "addNewClient": "Add Tenant",
    "saveChanges": "Save Changes",
    "createClient": "Create Tenant",
    "cancel": "Cancel",
    "form": {
      "clientName": "Tenant Name",
      "clientNameRequired": "Please enter a tenant name.",
      "clientNameMin": "Tenant name must be at least 2 characters.",
      "clientNameDuplicate": "A tenant with this name already exists.",
      "clientNameTooltip": "The display name for this tenant",
      "clientNamePlaceholder": "e.g., Acme Corporation",
      "clientKey": "Tenant Key",
      "clientKeyRequired": "Please enter a tenant key.",
      "clientKeyPattern": "Key must contain only lowercase letters, numbers, and hyphens.",
      "clientKeyDuplicate": "A tenant with this key already exists.",
      "clientKeyTooltip": "Unique identifier used in API calls (lowercase, alphanumeric, hyphens only)",
      "clientKeyPlaceholder": "e.g., acme-corp"
    },
    "messages": {
      "updateNotImplemented": "Update tenant functionality is not yet implemented",
      "createSuccess": "Tenant created successfully",
      "createError": "Failed to create tenant: {{error}}",
      "deleteNotImplemented": "Delete tenant functionality is not yet implemented"
    },
    "detail": {
      "backToClients": "Back to Tenants",
      "clientDetails": "Tenant Details",
      "clientDetailsSubtitle": "Tenant details and information",
      "errorLoading": "Error loading tenant: {{error}}",
      "clientNotFound": "Tenant not found.",
      "viewLogs": "View Logs",
      "editClient": "Edit Tenant",
      "deleteClient": "Delete Tenant",
      "clientInformation": "Tenant Information",
      "generateRegistrationLink": "Generate Registration Link",
      "clientName": "Tenant Name",
      "clientKey": "Tenant Key",
      "clientId": "Tenant ID",
      "createdAt": "Created At",
      "lastUpdated": "Last Updated",
      "status": "Status",
      "active": "Active",
      "companies": "Companies",
      "addCompany": "Add Company",
      "totalCompanies": "Total Companies",
      "edit": "Edit",
      "generateLink": "Generate Link",
      "noCompanies": "No companies associated with this tenant",
      "clientOwners": "Tenant Owners",
      "clientEmployees": "Tenant Employees",
      "clientCustomers": "Tenant Customers",
      "noOwnersFound": "No owners found",
      "noEmployeesFound": "No employees found",
      "noCustomersFound": "No customers found",
      "paginationOwners": "{{start}}-{{end}} of {{total}} owners",
      "paginationEmployees": "{{start}}-{{end}} of {{total}} employees",
      "paginationCustomers": "{{start}}-{{end}} of {{total}} customers",
      "table": {
        "user": "User",
        "status": "Status",
        "role": "Role",
        "joined": "Joined",
        "companies": "Companies",
        "companyName": "Company",
        "domain": "Domain",
        "city": "City",
        "country": "Country",
        "email": "Email",
        "actions": "Actions"
      },
      "generateInviteLink": "Generate Invite Link",
      "addMember": {
        "title": "Add Member",
        "description": "Add a user to tenant {{name}} with a client-level role.",
        "button": "Add Member",
        "selectUser": "User",
        "selectUserRequired": "Please select a user",
        "selectUserPlaceholder": "Select user",
        "role": "Role",
        "roleOwner": "Owner",
        "roleEmployee": "Employee",
        "add": "Add Member",
        "cancel": "Cancel",
        "memberAdded": "Member added successfully",
        "addError": "Failed to add member: {{error}}",
        "noUsersAvailable": "No users available to add"
      },
      "addToCompany": {
        "title": "Add to Company",
        "description": "Add a client member to {{company}}.",
        "descriptionAny": "Add a client member to a company.",
        "short": "Add to Company",
        "selectUser": "Client member",
        "selectUserRequired": "Please select a user",
        "selectUserPlaceholder": "Select user",
        "selectCompany": "Company",
        "selectCompanyRequired": "Please select a company",
        "selectCompanyPlaceholder": "Select company",
        "role": "Role",
        "roleOwner": "Owner",
        "roleEmployee": "Employee",
        "add": "Add to Company",
        "cancel": "Cancel",
        "added": "Added to company successfully",
        "error": "Failed to add to company: {{error}}",
        "noMembers": "No client members to add"
      },
      "removeFromCompany": {
        "confirmTitle": "Remove from company?",
        "confirmDesc": "This user will no longer be a member of this company.",
        "ok": "Remove",
        "cancel": "Cancel"
      },
      "removeFromTenant": {
        "confirmTitle": "Remove from tenant?",
        "confirmDesc": "This user will lose access to this tenant.",
        "button": "Remove",
        "ok": "Remove",
        "cancel": "Cancel"
      },
      "deleteCompany": {
        "confirmTitle": "Delete company?",
        "confirmDesc": "All members will be removed from this company. This cannot be undone.",
        "ok": "Delete",
        "cancel": "Cancel",
        "tooltip": "Delete company",
        "success": "Company deleted",
        "error": "Failed to delete company"
      },
      "activeStatus": "Active",
      "inactiveStatus": "Inactive",
      "emailVerified": "Email Verified",
      "emailUnverified": "Email Unverified",
      "phoneVerified": "Phone Verified",
      "phoneUnverified": "Phone Unverified",
      "token": {
        "title": "Generate Registration Link",
        "generatingForClient": "Generating registration link for Tenant: {{name}}",
        "generatingForCompany": "Generating registration link for Company: {{name}}",
        "selectRoleDescription": "Select a tenant role for the registration link. Users who register with this link will be assigned the selected role.",
        "tenantRole": "Tenant Role",
        "tenantRoleRequired": "Please select a tenant role",
        "tenantRolePlaceholder": "Select a tenant role",
        "tenantRoleTooltip": "Select the role that will be assigned to users who register using this link",
        "roleOwner": "Owner",
        "roleAdmin": "Admin",
        "roleEmployee": "Employee",
        "generateLink": "Generate Link",
        "close": "Close",
        "cancel": "Cancel",
        "successTitle": "Registration Link Generated Successfully",
        "successDescription": "This registration link can be used to invite users to this tenant with the specified role. Copy and share it securely.",
        "linkDetails": "Link Details",
        "tenantRoleLabel": "Tenant Role",
        "clientIdLabel": "Tenant ID",
        "companyIdLabel": "Company ID",
        "expiresAt": "Expires At",
        "registrationUrl": "Registration URL",
        "registrationLink": "Registration Link:",
        "copyRegistrationLink": "Copy Registration Link",
        "securityNotice": "Security Notice",
        "securityDescription": "This registration URL will be shown only once. Make sure to copy it before closing this dialog. Anyone with this URL can register and join the tenant with the specified role.",
        "tokenSuccess": "Token issued successfully",
        "tokenError": "Failed to issue token: {{error}}",
        "copySuccess": "Registration URL copied to clipboard!"
      },
      "messages": {
        "editNotImplemented": "Edit tenant functionality is not yet implemented",
        "deleteNotImplemented": "Delete tenant functionality is not yet implemented",
        "companyCreated": "Company created successfully",
        "companyCreateError": "Failed to create company: {{error}}",
        "companyUpdated": "Company updated successfully",
        "companyUpdateError": "Failed to update company: {{error}}"
      },
      "eventTriggers": {
        "title": "Event Triggers",
        "eventDescriptions": {
          "onAppointmentConfirmed": "Fired when an appointment is confirmed by the client or system.",
          "onAppointmentCreated": "Fired when a new appointment is created.",
          "onAppointmentRescheduled": "Fired when an existing appointment is rescheduled to a new time.",
          "onAppointmentRescheduleRequested": "Fired when a customer submits a reschedule request and the appointment enters pending review.",
          "onAppointmentRescheduleRequestRejected": "Fired when a reschedule request is rejected and the appointment is restored to its prior status.",
          "onAppointmentCancelled": "Fired when an appointment is cancelled.",
          "onAppointmentNoShow": "Fired when an appointment is marked as no-show.",
          "onAppointmentCompleted": "Fired when an appointment is marked as completed.",
          "onUserRegistered": "Fired when a new user completes registration.",
          "onThreadCreated": "Fired when a new chat or support thread is created.",
          "onThreadArchived": "Fired when a chat or support thread is archived.",
          "onConversationCompleted": "Fired when a call, chat, or email conversation is completed, with its summary and review flags.",
          "onCallFinished": "Fired when a phone call finishes.",
          "onLeadCreated": "Fired when an anonymous interaction becomes a lead.",
          "onLeadVerified": "Fired when a lead verifies at least one contact identifier.",
          "onLeadConverted": "Fired when a lead is converted to a customer or opportunity.",
          "onCustomerCreated": "Fired when a customer record is created from a verified lead or manually."
        },
        "subtitle": "Map domain events to flows for this tenant.",
        "eventType": "Event type",
        "flow": "Flow",
        "triggerNode": "Trigger node",
        "active": "Active",
        "addMapping": "Add Mapping",
        "addMappingTooltip": "Map a domain event to a flow trigger",
        "add": "Create Mapping",
        "cancel": "Cancel",
        "delete": "Delete",
        "allEvents": "All events",
        "allFlows": "All flows",
        "allNodes": "All nodes",
        "clearFilters": "Clear filters",
        "showingCount": "Showing {{count}} of {{total}} mappings",
        "empty": "No event mappings yet",
        "emptyHint": "Events like an appointment being created or a user registering can start automations.",
        "deleteTooltip": "Delete this mapping",
        "deleteConfirm": "Delete this mapping?",
        "deleteConfirmDescription": "This removes the event mapping. You can add it again later.",
        "selectEvent": "Select an event",
        "selectFlow": "Select a flow",
        "selectTriggerNode": "Select a trigger node",
        "selectFlowFirst": "Select a flow first",
        "addSuccess": "Event mapping created",
        "addError": "Failed to create the mapping",
        "deleteSuccess": "Mapping deleted",
        "deleteError": "Failed to delete the mapping",
        "enabledSuccess": "Mapping enabled",
        "disabledSuccess": "Mapping disabled",
        "updateError": "Failed to update the mapping"
      },
      "addCustomer": {
        "title": "Add Customer",
        "description": "Give an existing user customer access to tenant {{name}}.",
        "add": "Add Customer",
        "memberAdded": "Customer added",
        "addError": "Failed to add customer: {{error}}"
      },
      "customers": {
        "title": "Customers",
        "search": "Search name, email or phone",
        "invite": "Invite customer",
        "add": "Add Customer",
        "removed": "Customer removed from tenant",
        "removeError": "Failed to remove customer"
      },
      "backToTenant": "Back to tenant"
    },
    "logs": {
      "title": "Tenant logs",
      "clientNotFound": "Tenant not found.",
      "backToTenant": "Back to {{name}}",
      "clientLogsFor": "Logs – {{name}}",
      "subtitle": "Flow executions of this tenant and changes to its flows."
    },
    "modules": {
      "title": "Module Management",
      "backToClient": "Back to Tenant",
      "managingFor": "Managing modules for: {{name}}",
      "loadingModules": "Loading modules...",
      "noModulesMatch": "No modules match your current filters",
      "noModulesAvailable": "No modules available",
      "clearAllFilters": "Clear all filters"
    },
    "empty": "No tenants yet"
  },
  "users": {
    "title": "Users Management",
    "subtitle": "Review users and their tenant memberships.",
    "filters": "Filters",
    "client": "Client",
    "company": "Company",
    "role": "Role",
    "allClients": "All Clients",
    "allCompanies": "All Companies",
    "allRoles": "All Roles",
    "clearFilters": "Clear Filters",
    "search": "Search",
    "searchPlaceholder": "by name or email",
    "searchPending": "Searching…",
    "searchResults": "{{count}} users matching \"{{query}}\"",
    "noSearchResults": "No users match \"{{query}}\"",
    "paginationTotal": "{{start}}-{{end}} of {{total}} users",
    "columns": {
      "user": "User",
      "role": "Role",
      "tenants": "Tenants",
      "companies": "Companies",
      "status": "Status",
      "actions": "Actions"
    },
    "joined": "Joined: {{date}}",
    "none": "None",
    "more": "+{{count}} more",
    "emailVerified": "Email Verified",
    "emailUnverified": "Email Unverified",
    "phoneVerified": "Phone Verified",
    "phoneUnverified": "Phone Unverified",
    "view": "View",
    "verification": {
      "resendEmail": "Resend verification email",
      "markVerified": "Mark as verified",
      "resendSuccess": "Verification email sent.",
      "resendError": "Failed to resend verification email.",
      "verifySuccess": "Email marked as verified.",
      "verifyError": "Failed to verify email.",
      "verifyConfirmTitle": "Mark email as verified?",
      "verifyConfirmDescription": "This will allow {{name}} to log in without clicking the confirmation link.",
      "verifyConfirmOk": "Mark verified",
      "verifyConfirmCancel": "Cancel",
      "unverifiedAlertTitle": "Email not verified",
      "unverifiedAlertDescription": "{{email}} cannot log in until the email is verified. Resend the confirmation email or mark it verified manually."
    },
    "create": {
      "button": "Add User",
      "title": "Add User",
      "submit": "Create User",
      "cancel": "Cancel",
      "email": "Email",
      "emailRequired": "Email is required",
      "emailInvalid": "Enter a valid email address",
      "password": "Password",
      "passwordRequired": "Password is required",
      "passwordMin": "Password must be at least 8 characters",
      "passwordHint": "Must include uppercase, lowercase, number, and special character (@$!%*?&)",
      "name": "Name",
      "nameRequired": "Name is required",
      "phone": "Phone (optional)",
      "globalRole": "Global role",
      "tenantSectionHint": "Optional: assign the user to a client and company. The account is created with email already verified.",
      "client": "Client",
      "clientPlaceholder": "Select a client (optional)",
      "company": "Company",
      "companyPlaceholder": "Select a company (optional)",
      "tenantRole": "Tenant role",
      "tenantRoleEmployee": "Employee",
      "tenantRoleOwner": "Owner",
      "tenantRoleCustomer": "Customer",
      "success": "User created successfully.",
      "error": "Failed to create user: {{error}}"
    },
    "detail": {
      "title": "User Details",
      "backToUsers": "Back to Users",
      "errorLoading": "Error loading user: {{error}}",
      "subtitle": "User profile and tenant memberships.",
      "profile": "Profile",
      "globalRole": "Global Role",
      "verificationStatus": "Verification Status",
      "userId": "User ID",
      "createdAt": "Created At",
      "updatedAt": "Updated At",
      "loading": "Loading...",
      "userNotFound": "User not found.",
      "tenantMemberships": "Tenant Memberships",
      "companyMemberships": "Company Memberships",
      "table": {
        "client": "Client",
        "role": "Role",
        "status": "Status",
        "created": "Created",
        "company": "Company"
      },
      "owner": "Owner",
      "member": "Member",
      "active": "Active",
      "inactive": "Inactive",
      "tenantAccess": {
        "title": "Tenant access",
        "assign": "Assign to tenant",
        "emptyTitle": "This user has no tenant access yet",
        "emptyDescription": "Assign a tenant to give them access as owner, employee or customer.",
        "removeConfirmTitle": "Remove from {{tenant}}?",
        "removeConfirmDesc": "The user loses access to this tenant and all of its companies.",
        "removedFromTenant": "Removed from {{tenant}}",
        "missingTenantLink": "Company access without tenant membership.",
        "addTenantLink": "Add as employee",
        "tenantLinkAdded": "Added to tenant as employee",
        "companyRoleUpdated": "Company role updated",
        "removedFromCompany": "Removed from company",
        "noCompanies": "Not assigned to any company of this tenant.",
        "customerNoCompanies": "Customers have tenant-wide access and are not assigned to companies.",
        "actionError": "The change could not be saved",
        "assignTitle": "Assign to tenant",
        "assignSubmit": "Assign",
        "assignDescription": "Give {{name}} access to a tenant and, optionally, some of its companies.",
        "tenant": "Tenant",
        "tenantRequired": "Please select a tenant",
        "tenantRole": "Tenant role",
        "companies": "Companies",
        "companiesHint": "Optional. Owners and employees can also be added to companies later.",
        "companyRole": "Company role",
        "assigned": "Assigned to {{tenant}}",
        "assignPartial": "Assigned to {{tenant}}, but adding these companies failed: {{companies}}",
        "assignError": "Failed to assign tenant",
        "staffTitle": "Admins and developers are not assigned to tenants",
        "staffDescription": "Their global role already gives them access to every tenant.",
        "staffKeptNote": "Kept from before this user became an admin/developer. They have no effect now (the global role already gives access to every tenant) and apply again if the user is demoted."
      }
    },
    "empty": "No users found",
    "roleOptions": {
      "ADMIN": "Admin",
      "DEVELOPER": "Developer",
      "USER": "User",
      "CUSTOMER": "Customer"
    },
    "searchByNameOrEmail": "Search by name or email"
  },
  "roles": {
    "admin": "Admin",
    "user": "User",
    "customer": "Customer"
  },
  "roleEditor": {
    "cannotChangeOwnRole": "You cannot change your own role",
    "editTooltip": "Click to edit user role",
    "changeTitle": "Change User Role",
    "saveChanges": "Save Changes",
    "cancel": "Cancel",
    "editingFor": "Editing role for:",
    "selectNewRole": "Select New Role:",
    "current": "Current",
    "confirmTitle": "Role Change Confirmation",
    "confirmDescription": "You are about to change the user role to <strong>{{role}}</strong>.",
    "selectRole": "Please select a role",
    "noChanges": "No changes made",
    "updateSuccess": "User role updated successfully",
    "updateError": "Failed to update user role"
  },
  "modules": {
    "searchPlaceholder": "Search modules by name, ID, description, author, or category...",
    "all": "All ({{count}})",
    "enabled": "Enabled ({{count}})",
    "disabled": "Disabled ({{count}})",
    "filterByCategory": "Filter by category:",
    "allCategories": "All Categories",
    "columns": {
      "module": "Module",
      "id": "ID",
      "requiredRoles": "Required Roles",
      "configuration": "Configuration",
      "actions": "Actions"
    },
    "enabledStatus": "Enabled",
    "disabledStatus": "Disabled",
    "none": "None",
    "configRequired": "Configuration required to enable",
    "required": "Required",
    "notConfigured": "Not configured",
    "incomplete": "Incomplete",
    "missing": "Missing: {{fields}}",
    "complete": "Complete",
    "fullyConfigured": "Fully configured",
    "default": "Default",
    "configureModule": "Configure Module",
    "configureToEnable": "Configure to enable",
    "totalModules": "Total {{count}} modules",
    "enableModal": {
      "title": "Enable Module: {{name}}",
      "okText": "Enable Module",
      "cancel": "Cancel",
      "configRequired": "Configuration Required",
      "configRequiredDesc": "Please fill in all required fields to enable this module.",
      "noConfigRequired": "No Configuration Required",
      "noConfigRequiredDesc": "This module can be enabled without additional configuration."
    },
    "configModal": {
      "title": "Configure Module: {{name}}",
      "okText": "Save Configuration",
      "cancel": "Cancel",
      "moduleId": "Module ID",
      "version": "Version",
      "author": "Author",
      "description": "Description",
      "noDescription": "No description",
      "na": "N/A",
      "noSchema": "No Configuration Schema",
      "noSchemaDesc": "This module does not have a configuration schema defined.",
      "saveError": "Failed to save configuration"
    }
  },
  "conversationOverview": {
    "title": "Cross-Tenant Conversation Overview",
    "description": "Conversation activity across all tenants so problems can be spotted without opening each tenant.",
    "level1Title": "Per-tenant summary",
    "level2Title": "Detailed conversations",
    "yes": "Yes",
    "no": "No",
    "transferred": "Transferred to a staff member",
    "loadError": "Failed to load conversation overview data.",
    "emptyTenants": "No tenants found.",
    "emptyConversations": "No conversations for the selected filters.",
    "paginationTotal": "{{start}}-{{end}} of {{total}} conversations",
    "periods": {
      "today": "Today",
      "7d": "Last 7 days",
      "30d": "Last 30 days",
      "custom": "Custom"
    },
    "filters": {
      "tenant": "Tenant",
      "channel": "Channel",
      "flag": "Flag",
      "humanHandoff": "Human Handoff",
      "technicalIssue": "Technical issue",
      "clearAll": "Clear filters"
    },
    "columns": {
      "tenant": "Tenant",
      "total": "Total conversations",
      "technicalIssue": "Technical issue",
      "humanHandoff": "Human Handoff",
      "flaggedRed": "Flagged Red",
      "channel": "Channel",
      "startedAt": "Date and time",
      "duration": "Duration",
      "customerHelped": "Customer helped",
      "delay": "Delay",
      "callbackRequested": "Callback requested",
      "flag": "Flag",
      "summary": "Summary",
      "actions": "Actions"
    },
    "channel": {
      "call": "Call",
      "chat": "Chat",
      "email": "Email"
    },
    "flag": {
      "green": "Green",
      "red": "Red"
    },
    "duration": {
      "seconds": "{{seconds}}s",
      "minutesSeconds": "{{minutes}}m {{seconds}}s",
      "hoursMinutes": "{{hours}}h {{minutes}}m",
      "veryShort": "very short",
      "veryLong": "very long"
    },
    "details": "Details",
    "detail": {
      "back": "Back to overview",
      "notFound": "Conversation not found",
      "notFoundDescription": "This thread is missing or no longer available.",
      "openFlow": "Open flow",
      "copyThreadId": "Copy thread ID",
      "copyCallId": "Copy call ID",
      "copied": "Copied",
      "completion": "Completion",
      "identifiers": "Identifiers",
      "voice": "Call",
      "summary": "Summary",
      "started": "Started",
      "ended": "Ended",
      "customerHelped": "Customer helped",
      "technicalIssues": "Technical issue reasons",
      "contact": "Contact",
      "threadId": "Thread ID",
      "client": "Tenant",
      "companyId": "Company ID",
      "flowId": "Flow ID",
      "callId": "Call ID",
      "sessionId": "Session ID",
      "userId": "User ID",
      "status": "Status",
      "fromNumber": "From",
      "toNumber": "To",
      "callStatus": "Call status",
      "endReason": "End reason",
      "endCode": "End code",
      "provider": "Provider",
      "engine": "Engine",
      "transport": "Transport",
      "noFlow": "No flow assigned",
      "internalContext": "Internal context",
      "contextSummary": "Context summary",
      "voiceContext": "Voice completion context",
      "redFlagAlert": "This conversation is flagged red.",
      "technicalIssueAlert": "A technical issue was recorded for this conversation.",
      "turn": "Turn {{index}}",
      "openExecution": "Open execution",
      "noExecution": "No flow execution",
      "copyCorrelationId": "Copy correlation ID",
      "truncatedMessages": "The transcript may be incomplete. Only the latest 1000 messages were loaded.",
      "truncatedExecutions": "Some flow executions were not loaded. Matching turns may show no execution.",
      "emailSummaryOnly": "This email conversation is shown with its completion summary. The message transcript is not available on this page.",
      "noData": "—",
      "active": "Active",
      "archived": "Archived"
    }
  },
  "tenantPickers": {
    "tenantPlaceholder": "Select tenant",
    "noTenants": "No tenants available",
    "companyPlaceholder": "Select companies",
    "noCompanies": "This tenant has no companies"
  },
  "logs": {
    "view": "View",
    "pagination": "{{start}}–{{end}} of {{total}}",
    "emptyHint": "Try a longer period or clear the filters.",
    "refresh": "Refresh",
    "export": "Export CSV",
    "lastUpdated": "Updated {{time}}",
    "status": {
      "STARTED": "Running",
      "COMPLETED": "Completed",
      "FAILED": "Failed"
    },
    "tabs": {
      "executions": "Flow executions",
      "audit": "Audit trail"
    },
    "kpi": {
      "total": "Executions",
      "completed": "Completed",
      "failed": "Failed",
      "running": "Running"
    },
    "filters": {
      "allTenants": "All tenants",
      "allStatuses": "All statuses",
      "searchAudit": "Search user, action or entity",
      "clear": "Clear filters",
      "tenantLevel": "Tenant level",
      "company": "Company: {{name}}"
    },
    "executions": {
      "columns": {
        "time": "Time",
        "status": "Status",
        "tenant": "Tenant",
        "flow": "Flow",
        "duration": "Duration",
        "error": "Error",
        "correlationId": "Correlation ID"
      },
      "empty": "No flow executions in this period",
      "failedInNode": "Failed in node {{node}}"
    },
    "audit": {
      "columns": {
        "time": "Time",
        "user": "User",
        "action": "Action",
        "entity": "Entity ID"
      },
      "empty": "No audit entries in this period",
      "emptyHint": "Only flow and template creations and updates are recorded.",
      "actions": {
        "FLOW_CREATED": "Flow created",
        "FLOW_UPDATED": "Flow updated",
        "TEMPLATE_CREATED": "Template created",
        "TEMPLATE_UPDATED": "Template updated"
      }
    },
    "drawer": {
      "title": "Flow execution",
      "openInBackstage": "Open in Backstage",
      "startedAt": "Started",
      "duration": "Duration",
      "tenant": "Tenant",
      "template": "Template",
      "triggeredBy": "Triggered by",
      "executionId": "Execution ID",
      "correlationId": "Correlation ID",
      "userId": "User ID",
      "conversation": "Conversation",
      "openConversation": "Open conversation",
      "steps": "Steps",
      "noSteps": "No steps recorded for this execution",
      "triggerData": "Trigger data",
      "timings": "Timings",
      "failedNode": "Failed node"
    }
  }
}
